function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M381.7,4016.2c-117.6-53.9-193.5-132.3-245-252.4C104.9,3683,100,3325.3,100,669.5s4.9-3013.5,36.7-3094.3c51.5-120.1,127.4-198.5,245-252.4c93.1-44.1,274.4-46.6,4618.3-46.6s4525.2,2.4,4618.3,46.6c117.6,53.9,193.6,132.3,245,252.4c31.8,80.8,36.7,441,36.7,3101.7v3008.6l-53.9,107.8c-31.8,58.8-98,142.1-149.4,181.3l-95.6,76l-4559.4,4.9C648.8,4062.7,477.3,4060.3,381.7,4016.2z M9503.1,696.4c2.5-2168.3-2.4-2969.4-22-2993.9c-39.2-46.6-8913.1-51.5-8959.6-4.9c-22.1,22-29.4,717.8-29.4,2984.1c0,1626.8,7.3,2964.5,17.2,2971.8c7.3,9.8,2033.5,14.7,4500.6,12.2l4486-7.3L9503.1,696.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M5188.7,1901.8c-41.7-41.6-151.9-377.3-419-1266.6c-343-1134.4-362.6-1215.2-330.8-1274c56.3-100.4,149.5-134.8,252.3-90.6c98,41.6,36.7-127.4,529.2,1504.3c271.9,901.6,296.4,994.7,269.5,1060.9C5436.1,1965.5,5284.2,1997.4,5188.7,1901.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M3713.7,1884.7c-39.2-24.5-347.9-323.4-686-661.5l-612.5-615l661.5-661.5c597.8-597.8,668.8-661.5,742.3-661.5c100.4,0,200.9,93.1,200.9,188.7c0,53.9-98,164.2-526.7,595.3L2966.5,596l514.5,514.5c284.2,284.2,521.8,539,529.2,570.8c24.5,88.2-9.8,174-88.2,213.2C3828.9,1941,3802,1941,3713.7,1884.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M6041.2,1901.8c-73.5-44.1-107.8-98-110.3-178.8c0-61.3,75.9-147,526.8-597.8L6984.5,596L6452.9,64.3c-514.5-516.9-529.2-534.1-512-612.5c19.6-100.4,95.5-166.6,196-166.6c68.6,0,151.9,75.9,737.4,661.5l661.5,661.5L6911,1235.4c-343,343-654.2,641.9-690.9,661.5C6141.7,1938.6,6107.4,1938.6,6041.2,1901.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M3116-3522.5c-68.6-85.8-63.7-164.2,7.3-247.5l58.8-68.6h1840h1837.5l56.3,53.9c75.9,75.9,73.5,218-2.5,279.3c-53.9,44.1-134.7,46.6-1901.2,46.6H3165L3116-3522.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projectsIcon.b6f080ad.svg";
export { ForwardRef as ReactComponent };